import {
  Collapse,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import VideocamIcon from "@material-ui/icons/Videocam";
import React from "react";
import { Link } from "react-router-dom";
import logoHorizontal from "../../assets/logo_horizontal.png";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  card: {
    margin: "auto",
    padding: "3%",
  },
  link: {
    color: "black",
  },
  type: {
    padding: "1rem",
  },
  divid: {
    borderBottom: " 2px solid lightgrey",
    width: "100%",
  },
});

export default function Drawer() {
  const { t } = useTranslation(["components"]);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openl, setOpenl] = React.useState(false);

  const handleClick = () => {
    setOpenl(!openl);
  };
  return (
    <div>
      <IconButton edge="start" color="inherit" onClick={() => setOpen(true)}>
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <div className={classes.list}>
          <Typography className={classes.type}>
            <img src={logoHorizontal} alt="logo psycare" />
          </Typography>
          <Divider className={classes.divid} />
          <List className={classes.li}>
            <ListItem
              className={classes.link}
              component={Link}
              to="/"
              onClick={() => setOpen(false)}
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary={"Home"} />
            </ListItem>

            <ListItem button onClick={handleClick}>
              <ListItemIcon>
                <ChromeReaderModeIcon />
              </ListItemIcon>

              <ListItemText primary={t("components:drawer.therapists")} />
              {openl ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openl} timeout="auto" unmountOnExit>
              <List>
                <ListItem
                  className={classes.link}
                  component={Link}
                  to="/therapists"
                  onClick={() => setOpen(false)}
                >
                  <div
                    style={{
                      paddingLeft: "1rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ListItemIcon>
                      <PeopleAltIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("components:drawer.therapists_list")} />
                  </div>
                </ListItem>
                <ListItem
                  className={classes.link}
                  component={Link}
                  to="/session"
                  onClick={() => setOpen(false)}
                >
                  <div
                    style={{
                      paddingLeft: "1rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ListItemIcon>
                      <VideocamIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("components:drawer.sessions_list")} />
                  </div>
                </ListItem>
              </List>
            </Collapse>
            <ListItem
              className={classes.link}
              component={Link}
              to="/patients"
              onClick={() => setOpen(false)}
            >
              <ListItemIcon>
                <PeopleAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("components:drawer.patients_list")} />
            </ListItem>
          </List>
        </div>
      </SwipeableDrawer>
    </div>
  );
}
